import React from 'react'

import { withRouter } from 'react-router-dom'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleLeft } from '@fortawesome/free-solid-svg-icons'

const BotonBack = ({ history }) => {
    return (
        <button
            type="button"
            className="btn btn-outline-warning btn-lg"
            onClick={() => {
                /*Si estamos en /apertura-caja, siempre va a volver a la home.
                Esto ocurre porque en useVenta se verifica que exista una caja abierta, sino te redirecciona y por eso falla el goBack*/
                if (history.location.pathname === '/apertura-caja') {
                    history.push('/')
                } else {
                    history.goBack()
                }
            }}
        >
            <FontAwesomeIcon icon={faArrowAltCircleLeft} /> Volver
        </button>
    )
}

export default withRouter(BotonBack)
